module.exports = __webpack_public_path__ + "img/total-2.662869b0.svg";